/* Rod Armour — bundle-builder controller (Opus 4.7 12-May)
   Config injected via window.RA_BB by snippets/bundle-builder.liquid */
  (function() {
    'use strict';

    /* ═══════════════════════════════════════════
       BUNDLE BUILDER — VANILLA JS CONTROLLER
       ═══════════════════════════════════════════ */

    const STRINGS = window.RA_BB.strings;

    const TIERS = [
      { buy: 3, free: 1, total: 4 },
      { buy: 6, free: 2, total: 8 },
      { buy: 9, free: 3, total: 12 },
    ];

    const PRICE = window.RA_BB.price;

    const root = document.getElementById('bundle-builder');
    if (!root) return;
    let initialized = false;

    function closeOpenSizeGuide() {
      const openDialog = document.querySelector('dialog.size-modal[open]');
      if (openDialog && typeof openDialog.close === 'function') {
        openDialog.close();
      } else if (openDialog) {
        openDialog.removeAttribute('open');
      }
    }

    function openSizeGuide(sourceTrigger) {
      const finder = document.querySelector('[data-ra-sleeve-finder]');
      if (finder && typeof finder.raSleeveFinderOpen === 'function') {
        finder.raSleeveFinderOpen(sourceTrigger || null);
        return;
      }

      const trigger = document.querySelector('[data-sg-open]');
      if (trigger) {
        trigger.click();
      }
    }

    function initBundleBuilder() {
      if (initialized) return;
      initialized = true;

      function interpolate(template, replacements) {
      let output = template;

      Object.keys(replacements).forEach(key => {
        output = output.split('__' + key + '__').join(String(replacements[key]));
      });

      return output;
    }

    // State
    const state = {};
    const rows = root.querySelectorAll('.bb-size-row');
    rows.forEach(row => {
      state[row.dataset.variantId] = 0;
    });

    // DOM refs
    const accordion = {
      header: root.querySelector('.bb-accordion__header'),
      body: root.querySelector('.bb-accordion__body'),
    };
    const progress = {
      fill: root.querySelector('.bb-progress__fill'),
      markers: root.querySelectorAll('.bb-progress__marker'),
      markersContainer: root.querySelector('.bb-progress__markers'),
      message: root.querySelector('.bb-progress__message'),
      messageText: root.querySelector('.bb-progress__message-text'),
    };
    const tiers = root.querySelectorAll('.bb-tier');
    const footer = {
      count: root.querySelector('.bb-footer__count'),
      freeCount: root.querySelector('.bb-footer__free-count'),
      savings: root.querySelector('.bb-footer__savings'),
      savingsAmount: root.querySelector('.bb-footer__savings-amount'),
      cta: root.querySelector('.bb-footer__cta'),
      ctaText: root.querySelector('.bb-footer__cta-text'),
    };
    const autoDiscount = root.querySelector('.bb-auto-discount');

    function isLocalThemePreview() {
      return window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
    }

    function parseCartAddResponse(response) {
      return response.text().then(text => {
        const trimmed = text ? text.trim() : '';
        let data = null;

        if (trimmed) {
          try {
            data = JSON.parse(trimmed);
          } catch (error) {
            if (response.ok) {
              throw { message: 'Cart returned an unreadable response.' };
            }
          }
        }

        if (!response.ok || (data && data.status === 422)) {
          if (response.status === 401 && isLocalThemePreview()) {
            throw { message: 'Preview cart blocked' };
          }
          if (data) {
            throw data;
          }
          throw { message: 'Cart add failed' };
        }

        return data || {};
      });
    }

    function getCartAddErrorMessage(error) {
      if (error && typeof error.description === 'string') return error.description;
      if (error && typeof error.message === 'string') return error.message;
      return STRINGS.errorTryAgain;
    }

    /* ─── Accordion Toggle ─── */
    accordion.header.addEventListener('click', () => {
      closeOpenSizeGuide();
      const expanded = accordion.header.getAttribute('aria-expanded') === 'true';
      accordion.header.setAttribute('aria-expanded', !expanded);
      accordion.body.classList.toggle('bb-accordion__body--open');
    });

    const sizeGuideLink = root.querySelector('[data-bb-size-guide-open]');
    if (sizeGuideLink) {
      sizeGuideLink.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        openSizeGuide(sizeGuideLink);
      });
    }

    /* ─── Stepper Events ─── */
    rows.forEach(row => {
      const vid = row.dataset.variantId;
      const incBtn = row.querySelector('.bb-stepper__btn--inc');
      const decBtn = row.querySelector('.bb-stepper__btn--dec');

      incBtn.addEventListener('click', () => {
        closeOpenSizeGuide();
        state[vid]++;
        render();
      });

      decBtn.addEventListener('click', () => {
        closeOpenSizeGuide();
        if (state[vid] > 0) {
          state[vid]--;
          render();
        }
      });
    });

    /* ─── CTA Click ─── */
    footer.cta.addEventListener('click', () => {
      closeOpenSizeGuide();
      const total = getTotal();
      if (total <= 0) return;

      // Build line items and add to cart via Shopify AJAX API
      const items = [];
      rows.forEach(row => {
        const vid = row.dataset.variantId;
        if (state[vid] > 0) {
          items.push({ id: parseInt(vid), quantity: state[vid] });
        }
      });

      if (items.length === 0) return;

      // Show claimed state
      footer.cta.className = 'bb-footer__cta bb-footer__cta--claimed';
      footer.cta.disabled = true;
      footer.ctaText.textContent = '✓ ' + STRINGS.dealClaimed;

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      })
      .then(parseCartAddResponse)
      .then(() => {
        // Trigger cart drawer / update cart count
        document.dispatchEvent(new CustomEvent('cart:updated'));
        // Optional: trigger Shopify section rendering event
        if (window.Shopify && window.Shopify.theme) {
          document.dispatchEvent(new Event('cart:refresh'));
        }
        document.dispatchEvent(new CustomEvent('ra:cart:open', {
          bubbles: true,
          detail: { source: 'bundle-builder' }
        }));

        setTimeout(() => {
          render(); // Reset CTA state
        }, 1600);
      })
      .catch(err => {
        if (window.Shopify && window.Shopify.designMode) {
          console.warn('Bundle add to cart failed:', err);
        }
        footer.cta.className = 'bb-footer__cta bb-footer__cta--teaser';
        footer.cta.disabled = false;
        footer.ctaText.textContent = getCartAddErrorMessage(err);
        setTimeout(() => render(), 3000);
      });
    });

    /* ─── Computed Values ─── */
    function getTotal() {
      return Object.values(state).reduce((a, b) => a + b, 0);
    }

    function getTierInfo(total) {
      let unlockedTier = null;
      let nextTier = TIERS[0];

      for (let i = TIERS.length - 1; i >= 0; i--) {
        if (total >= TIERS[i].total) {
          unlockedTier = TIERS[i];
          nextTier = TIERS[i + 1] || null;
          break;
        }
      }

      if (!unlockedTier) nextTier = TIERS[0];

      const targetTier = nextTier || unlockedTier;
      const prog = targetTier ? Math.min(total / targetTier.total, 1) : 1;
      const remaining = targetTier ? Math.max(targetTier.total - total, 0) : 0;
      const freeCount = Math.floor(total / 4);
      const paidCount = total - freeCount;

      return { unlockedTier, nextTier, targetTier, progress: prog, remaining, freeCount, paidCount, savings: freeCount * PRICE };
    }

    /* ─── Render ─── */
    function render() {
      const total = getTotal();
      const info = getTierInfo(total);

      // Update size rows
      rows.forEach(row => {
        const vid = row.dataset.variantId;
        const count = state[vid];
        const countEl = row.querySelector('.bb-stepper__count');
        const badge = row.querySelector('.bb-size-row__count-badge');
        const decBtn = row.querySelector('.bb-stepper__btn--dec');

        countEl.textContent = count;
        decBtn.disabled = count === 0;

        if (count > 0) {
          row.classList.add('bb-size-row--active');
          badge.textContent = '×' + count;
          badge.style.display = '';
        } else {
          row.classList.remove('bb-size-row--active');
          badge.style.display = 'none';
        }
      });

      // Update tier badges
      tiers.forEach(tierEl => {
        const tierTotal = parseInt(tierEl.dataset.tierTotal);
        const subEl = tierEl.querySelector('.bb-tier__sub');
        tierEl.classList.remove('bb-tier--active', 'bb-tier--next');

        if (total >= tierTotal) {
          tierEl.classList.add('bb-tier--active');
          subEl.textContent = '✓ ' + STRINGS.unlocked;
        } else if (info.targetTier && tierTotal === info.targetTier.total) {
          tierEl.classList.add('bb-tier--next');
          subEl.textContent = interpolate(STRINGS.pickTotal, { total: tierTotal });
        } else {
          subEl.textContent = interpolate(STRINGS.pickTotal, { total: tierTotal });
        }
      });

      // Update progress markers
      const target = info.targetTier || TIERS[0];
      const t = target.total;
      const markerFragment = document.createDocumentFragment();

      function appendMarker(stepValue, filled, isFree) {
        const marker = document.createElement('span');
        marker.className = 'bb-progress__marker';
        marker.dataset.step = String(stepValue);

        if (filled) marker.classList.add('bb-progress__marker--filled');
        if (isFree) marker.classList.add('bb-progress__marker--free');

        marker.textContent = isFree ? STRINGS.freeLabel : String(stepValue);
        markerFragment.appendChild(marker);
      }

      if (t <= 6) {
        for (let i = 1; i <= t; i++) {
          appendMarker(i, total >= i, i === t);
        }
      } else {
        const points = [1, Math.floor(t / 3), Math.floor(2 * t / 3), t];
        points.forEach(p => {
          appendMarker(p, total >= p, p === t);
        });
      }
      progress.markersContainer.replaceChildren(markerFragment);

      // Update progress bar
      progress.fill.style.width = (info.progress * 100) + '%';
      if (info.freeCount > 0) {
        progress.fill.classList.add('bb-progress__fill--unlocked');
      } else {
        progress.fill.classList.remove('bb-progress__fill--unlocked');
      }

      // Update progress message
      if (info.freeCount > 0) {
        let msg = interpolate(
          info.freeCount === 1 ? STRINGS.bxgyUnlockedOne : STRINGS.bxgyUnlockedOther,
          { count: info.freeCount }
        );
        if (info.nextTier) {
          msg += ' | ' + interpolate(STRINGS.bxgyNeed, {
            need: info.remaining,
            count: info.nextTier.free
          });
        }
        progress.messageText.textContent = msg;
        progress.message.classList.add('bb-progress__message--unlocked');
      } else if (total === 0) {
        progress.messageText.textContent = interpolate(STRINGS.mixerProgress, {
          total: target.total,
          free: target.free
        });
        progress.message.classList.remove('bb-progress__message--unlocked');
      } else {
        progress.messageText.textContent = interpolate(STRINGS.bxgyNeed, {
          need: info.remaining,
          count: target.free
        });
        progress.message.classList.remove('bb-progress__message--unlocked');
      }

      // Update footer
      footer.count.textContent = total;

      if (info.freeCount > 0) {
        footer.freeCount.textContent = interpolate(
          info.freeCount === 1 ? STRINGS.freeCountOne : STRINGS.freeCountOther,
          { count: info.freeCount }
        );
        footer.freeCount.style.display = '';
      } else {
        footer.freeCount.style.display = 'none';
      }

      if (info.savings > 0) {
        footer.savingsAmount.textContent = info.savings.toFixed(2);
        footer.savings.style.display = '';
      } else {
        footer.savings.style.display = 'none';
      }

      // CTA state
      if (total === 0) {
        footer.cta.className = 'bb-footer__cta bb-footer__cta--disabled';
        footer.cta.disabled = true;
        footer.ctaText.textContent = STRINGS.pickSizes;
      } else if (info.freeCount > 0) {
        footer.cta.className = 'bb-footer__cta bb-footer__cta--claim';
        footer.cta.disabled = false;
        footer.ctaText.textContent = STRINGS.claimDeal;
      } else {
        footer.cta.className = 'bb-footer__cta bb-footer__cta--teaser';
        footer.cta.disabled = false;
        footer.ctaText.textContent = STRINGS.addSelected + ' (' + total + ')';
      }

      // Auto discount note
      autoDiscount.style.display = total > 0 ? 'flex' : 'none';
    }

      // Initial render
      render();
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        if (!entries.some(function(entry) { return entry.isIntersecting || entry.intersectionRatio > 0; })) return;
        observer.disconnect();
        initBundleBuilder();
      }, { rootMargin: '300px 0px' });

      observer.observe(root);
    } else {
      initBundleBuilder();
    }

    document.addEventListener('click', function(event) {
      const sizeGuideTrigger = event.target.closest('[data-bb-size-guide-open]');
      if (!sizeGuideTrigger || !root.contains(sizeGuideTrigger)) return;

      event.preventDefault();
      event.stopPropagation();

      openSizeGuide(sizeGuideTrigger);
    }, true);
  })();
